import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListOptionsComponent } from './list-options.component';

const routes: Routes = [{ path: '', component: ListOptionsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ListOptionsRoutingModule { }
